export const environment = {
  type:'prod',
  production: true,
  dna: 'http://localhost:3717',
  bff: 'http://localhost:5001'
};
